<template>
  <div class="modal-parametros">
    <div class="header">
      <div class="close">
        <v-icon @click="returnScreen()" color="white">mdi-close</v-icon>
      </div>
      <h2>Indicadores</h2>
    </div>
    <v-tabs :show-arrows="false" v-model="tab" fixed-tabs align-with-title background-color="#F5F5F5" color="#48B38B" style="padding-top: 85px;">
      <v-tabs-slider color="#48B38B"></v-tabs-slider>
      <v-tab style="padding: 0px !important; margin: 0 !important;">
        Geral
      </v-tab>
      <v-tab>
        Equipe
      </v-tab>
      <v-tab>
        Financeiro
      </v-tab>
    </v-tabs>
    <div class="body">
      <!-- <div class="classification-content">
        <div class="classification ultimate">
          PREMIUM
          <v-icon color="#fff">mdi-check-decagram</v-icon>
        </div>
      </div> -->
      <div class="score">
        <v-rating
          class="mt-1"
          size="30px"
          v-model="rating"
          bg-color="white"
          color="white"
        ></v-rating>
        <div class="rate">
          4.7 / 5
        </div>
        <div class="score-text">Média de avaliações (últimos 6 meses)</div>
      </div>

      <div class="score">
        <div class="rate mr-2">
          84h
        </div>
        <div class="rate">
          3d
        </div>
        <div class="score-text">Tempo médio de permanencia dos veículos</div>
      </div>
    </div>
  </div>
  </template>

<script>
export default {
  name: 'Dashboards',
  data: () => ({
    tab: 0,
    loading: true,
    rating: 5
  }),
  mounted() {

  },
  methods: {
    returnScreen() {
      this.$emit('return');
    },
  },
  watch: {
  },
};
</script>

<style lang="scss">

.modal-parametros {

  .classification-content {
    min-height: 200px;
    background-color: #eee;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;

    .classification {
      margin-top: 10px;
      border-radius: 8px;
      padding: 20px;
      color: #fff;
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 3px;
      overflow:hidden;
      position: relative;

      .v-icon {
        padding-top: 3px;
        float: right;
      }

      &:after {
        content:'';
        top:0;
        transform:translateX(100%) rotate(30deg);
        width:300%;
        height:300%;
        position: absolute;
        z-index:1;
        animation: shine 2s ease-in;
        background:
          linear-gradient( to right,
            rgba(255,255,255,0) 0%,
            rgba(255,255,255,0.8) 50%,
            rgba(128,186,232,0) 99%,
            rgba(128,186,232,0) 100%);
      }

      &.platinum {
        background: #abbaab;
        background: -webkit-linear-gradient(to left, #eee, #c7c7c7);
        background: linear-gradient(to left, #eee, #c7c7c7);
      }

      &.gold {
        background: #FF8008;
        background: -webkit-linear-gradient(to right, #FFC837, #FF8008);
        background: linear-gradient(to right, #FFC837, #FF8008);
      }

      &.ultimate {
        background: #000000;
        background: -webkit-linear-gradient(to right, #6d6d6d, #000000);
        background: linear-gradient(to right, #6d6d6d, #000000);
        border: 3px solid #d1d1d1;
      }
    }
  }

  .score {
    margin-top: 20px;
    background-color: rgb(72, 179, 139);
    padding: 10px;
    border-radius: 5px;
    transition: all .5s;
    animation: pulser 3s infinite;
    overflow: hidden;

    .v-rating {
      float: left;
      text-align: center;
      width: 73%;
    }

    .rate {
      width: 27%;
      background-color: #269169;
      text-align: center;
      float: left;
      padding: 12px 16px;
      color: #fff;
      border-radius: 6px;
      font-size: 18px;
      font-weight: 500;
    }

    .score-text {
      float: left;
      text-align: center;
      width: -webkit-fill-available;
      margin-top: 10px;
      margin-right: 5px;
      margin-left: 5px;
      padding-top: 8px;
      border-top: 1px solid #26a173;
      color: #fff;
    }
  }
}

@keyframes shine {
  0% {
      transform:translateX(-100%) translateY(-100%) rotate(30deg);
  }
  80% {transform:translateX(-100%) translateY(-100%) rotate(30deg);}
	100% {transform:translateX(100%) translateY(100%) rotate(30deg);}
}

@keyframes pulser {
  0% {
    box-shadow: 0 0 0 0 rgba(72, 179, 139, .5);
  }
  60% {
    box-shadow: 0 0 0 10px rgba(251, 140, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 10px rgba(251, 140, 0, 0);
  }
}
</style>
